import { getLorebookProfileIndicatorData } from "./profileIndicator";
export default function getCharacterLorebookProfileIndicator({ character, isCreator, }) {
    const indicator = getLorebookProfileIndicatorData(character?.lorebooks, isCreator);
    if (indicator || !character?.has_private_lorebook) {
        return indicator;
    }
    return {
        id: null,
        name: "",
        isPrivate: true,
        isInteractionDisabled: true,
        canNavigate: false,
    };
}
